{
	"API_HOST": "api.phaze.app",
	"WS_HOST": "ws.phaze.app",
	"SENTRY_DSN": "https://5d0b426122350ea0b8501fcfc0e9029d@o4509005514407936.ingest.us.sentry.io/4510880625328128",
	"SEGMENT_WRITE_KEY": "AkuSX3ylBoSC5UsDF69XVGpJcVxSWwpI",
	"ENVIRONMENT": "prod"
}
